import keys from "lodash/keys";
import { DSIconAppearance } from "@/src/design_system/primitives/icon/types";
import { defineAsyncComponent } from "vue";

const files = import.meta.glob("@public/icons/**/*.svg");

const defineAsyncIconComponent = (appearance: DSIconAppearance, fileName: string) => {
  return keys(files).some(file => file.includes(`icons/${appearance}/${fileName}.svg`))
    ? defineAsyncComponent(() => import(`@public/icons/${appearance}/${fileName}.svg`))
    : null;
};

export const iconComponentManager = (iconNames: string[], appearance: DSIconAppearance) => {
  return iconNames.reduce(
    (acc, name) => {
      acc[name] = defineAsyncIconComponent(appearance, name);
      return acc;
    },
    {} as Record<string, ReturnType<typeof defineAsyncComponent> | null>
  );
};
